import { customSpringAxios } from "./axios";

export const getPricesAPI = async ({ rateCardId, stationId1, stationId2, tripId, journeyDate }) => {
    const response = await customSpringAxios.post("/getPrices", {
        rateCardId,
        stationId1,
        stationId2,
        tripId,
        journeyDate,
    });
    return response.data;
};
